export default __webpack_public_path__ + "static/viedoArrow-e2b10fb02b330e7356d1f4e0cd40466a.svg";